import { ExtractPropTypes } from 'vue';

export const props = {
  as: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
};

export type Const = ExtractPropTypes<typeof props>
